import React, { useEffect, useRef, useState } from "react";
import FooterButton from "../FooterButton";
import ActiveSessions from "./components/ActiveSessions";
import ChangePassword from "./components/ChangePassword";
import ProfilePrivacy from "./components/ProfilePrivacy";
import {
  usePrivacyUpdate,
  useSessionSettings,
  useupdateAuthentication,
} from "hooks/api/useSettings";
import "./style.scss";
import { useNavigate } from "react-router-dom";

function SecurityAndPrivacy({ data }) {
  const changePasswordRef = useRef();
  const navigate = useNavigate();
  // api
  const { mutate: updateAuthentication, isLoading: authLoading } =
    useupdateAuthentication({
      onSuccess: () => {
        navigate("/login");
      },
    });
  const { mutate: updatePrivacy, isLoading: updateLoad } = usePrivacyUpdate();

  const [privacyData, setPrivacyData] = useState({
    profile_type: 1,
    privacy_for_interested_in: false,
    privacy_for_favorited: false,
    privacy_for_visited: false,
  });
  useEffect(() => {
    if (data?.privacy_settings_data) {
      setPrivacyData({
        profile_type: data.privacy_settings_data.profile_type,
        privacy_for_interested_in:
          data.privacy_settings_data.privacy_for_interested_in,
        privacy_for_favorited: data.privacy_settings_data.privacy_for_favorited,
        privacy_for_visited: data.privacy_settings_data.privacy_for_visited,
      });
    }
  }, [data]);
  const updatePrivacyData = (key, value) => {
    setPrivacyData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };
  const buildPrivacyPayload = () => {
    const { profile_type, ...flags } = privacyData;

    if (profile_type === 1 || profile_type === 2) {
      return { profile_type };
    }

    return { profile_type, ...flags };
  };

  const { data: sessionData, isLoading: isInterestedLoading } =
    useSessionSettings({
      device_id: localStorage.getItem("deviceId"),
    });

  const dataArray = sessionData?.session_list;
  const sortedData = dataArray?.map((eachItem) => {
    return {
      browser: eachItem.device_name,
      device: "Windows",
      isCurrentSession: eachItem.current_Session,
      lastLoggedIn: eachItem.last_login,
      location: eachItem.location,
      id: eachItem?.id,
      icon: eachItem?.icon || "chrome",
    };
  });

  return (
    <div className="tab-content security-privacy-tab">
      <h1 className="tab-title ">Security & privacy</h1>
      <ChangePassword ref={changePasswordRef} />
      <ProfilePrivacy
        updatePrivacyData={updatePrivacyData}
        privacyData={privacyData}
      />
      <ActiveSessions activeSessionData={sortedData || []} />
      <FooterButton
        isLoading={updateLoad || authLoading}
        onSave={() => {
          const payload = changePasswordRef.current?.getValues();
          const anyPasswordFilled =
            payload.current_password ||
            payload.new_password ||
            payload.confirm_password;

          if (anyPasswordFilled) {
            if (!changePasswordRef.current.validate()) {
              return;
            }
            updateAuthentication(payload);
          }

          const privacyPayload = buildPrivacyPayload();
          updatePrivacy(privacyPayload);
        }}
      />
    </div>
  );
}

export default SecurityAndPrivacy;
